<!--
 * @Author: chenyangui
 * @Description: 审批流程 - 付款通知单设置
-->

<template>
    <div  style="min-height: 500px;">
        <el-row :gutter="20">

            <!-- left el-tree -->
            <el-col :span="6">
                <l-tree>
                    <template slot-scope="{treeData}">
                        <el-tree
                            id="lTree"
                            :data="treeData.list"
                            :props="treeData.defaultProps"
                            :highlight-current="true"
                            @node-click="handleNodeClick"
                        ></el-tree>
                    </template>
                </l-tree>
            </el-col>

            <!-- el-table -->
            <el-col :span="18">
                <!-- button 新增 -->
                <header style="margin-bottom: 10px; text-align: right;">
                    <el-button size="small" @click="handleNewAddClick">{{$t('payApvlSet.newAdd'/**新增*/)}}</el-button>
                </header>

                <r-table :orgId="orgId" ref="rTable">
                    <template v-slot:editButton="{row}">
                        <el-button size="small" @click="handleEditClick(row)">{{$t('payApvlSet.edit'/**编辑*/)}}</el-button>
                    </template>
                    <template v-slot:disableButton="{row}">

                        <el-button size="small" @click="handleDisableClick(row)">{{row.status === '90110002'?'启用':'禁用'}}</el-button>
                    </template>
                </r-table>
            </el-col>

        </el-row>

        <!-- dialog 新增 编辑 弹窗 -->
        <el-dialog
            v-dialog-drag
            :title="isEdit ? $t('payApvlSet.editProcessTitle'/**编辑*/) : $t('payApvlSet.newProcessTitle'/**新增*/)"
            width="60%"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            @closed="handleClearProcessDialogData"
        >
            <process-dialog ref="processDialog">
                <template v-slot:submitButton="{postSaveFn}">
                   <el-button @click="onSubmit(postSaveFn)">{{$t('payApvlSet.save'/**保存*/)}}</el-button>
                </template>
            </process-dialog>
        </el-dialog>
    </div>
</template>

<script>
/**
 * API
 * - postPayApvlUpdateStatus   禁用 启用
 */
import { postPayApvlUpdateStatus } from '@/api/wage/paymentApproval'

import lTree from './components/l-tree'
import rTable from './components/r-table'
import processDialog from './components/process-dialog'

export default {
    name: 'payApvlSet',

    components: { lTree, rTable, processDialog },

    data() {
        return {
            orgId: '',              // 组织机构id
            isEdit: false,          // 新增 or 编辑
            dialogVisible: false,   // dialog 显示/隐藏
        }
    },

    methods: {
        /** left el-tree */
        /**
         * @description: 点击tree
         */
        handleNodeClick(data) {
            this.orgId = data.id
        },


        /** right el-table opreation */
        /**
         * @description r-table子组件 更新表格数据
         */
        updateRTableData() {
            // ! 子组件 r-table 方法
            this.$refs.rTable.updateRTableData()
        },

        /**
         * @description 新增
         */
        handleNewAddClick() {
            this.dialogVisible = true
            this.isEdit = false
        },

        /**
         * @description 编辑
         */
        handleEditClick(row) {
            this.dialogVisible = true
            this.isEdit = true

            // ! process-dialog子组件 方法
            this.$nextTick(() => {
                this.$refs.processDialog.getPayApvlEdit({ orgId: this.orgId, ...row })
            })
        },

        /**
         * @description 禁用
         */
        handleDisableClick(row) {
            let firstParam = row.status === '90110002' ? this.$t('payApvlSet.enaText'/**确定将所选流程启用吗*/) : this.$t('payApvlSet.disText'/**确定将所选流程禁用吗*/)
            this.$confirm(firstParam, this.$t('payApvlSet.disTitle'/**提示*/), {
                confirmButtonText: this.$t('payApvlSet.determine'/**确定*/),
                cancelButtonText: this.$t('payApvlSet.cancel'/**取消*/),
                type: 'warning'
            }).then(() => {
                let parmas = {
                    status: row.status === '90110002' ? '90110001' : '90110002',    // 90110002 禁用 90110001 启用
                    processId: row.id
                }
                postPayApvlUpdateStatus(parmas).then(res => {
                    if (res.data.code === 0) {
                        this.$message.success(this.$t('payApvlSet.successTips'/**成功*/))
                        this.updateRTableData()
                    }
                })
            }).catch(() => {
                this.$message.info(this.$t('payApvlSet.cancelTips'/**已取消*/))
            })
        },

        /**
         * @description process-dialog子组件 清空数据
         */
        handleClearProcessDialogData() {
            // ! process-dialog子组件 方法
            this.$refs.processDialog.resetForm()
        },

        /**
         * @description process-dialog子组件 新增 编辑弹窗
         */
        onSubmit(postSaveFn) {
            postSaveFn(this.orgId).then(bool => {
                if (bool) this.updateRTableData()
            })
        }

    }

}

</script>
